import type {
  AgentCloudTestConfigChange,
  AgentCloudTestConfigFields,
  AgentTestOperation,
  Period,
} from '../../../../types';
import { isAgentCloudTestCreateChange } from '../../../../types';

const formatPeriod = (p: Period | null | undefined): string =>
  p ? `${p.count} ${p.period}` : 'none';

export const formatCloudTestConfigFieldsSummary = (
  fields: AgentCloudTestConfigFields,
): string => {
  const parts: string[] = [];

  if (fields.sensitivity)
    parts.push(
      `sensitivity: ${fields.sensitivity.current ?? 'none'} \u2192 ${
        fields.sensitivity.new
      }`,
    );
  if (fields.threshold)
    parts.push(
      `threshold: ${formatPeriod(
        fields.threshold.current,
      )} \u2192 ${formatPeriod(fields.threshold.new)}`,
    );
  if (fields.anomalyDirection)
    parts.push(
      `direction: ${fields.anomalyDirection.current ?? 'none'} \u2192 ${
        fields.anomalyDirection.new
      }`,
    );
  if (fields.detectionPeriod)
    parts.push(
      `detection: ${formatPeriod(
        fields.detectionPeriod.current,
      )} \u2192 ${formatPeriod(fields.detectionPeriod.new)}`,
    );
  if (fields.trainingPeriod)
    parts.push(
      `training: ${formatPeriod(
        fields.trainingPeriod.current,
      )} \u2192 ${formatPeriod(fields.trainingPeriod.new)}`,
    );
  if (fields.severity)
    parts.push(
      `severity: ${fields.severity.current ?? 'none'} \u2192 ${
        fields.severity.new
      }`,
    );
  if (fields.owners)
    parts.push(
      `owners: ${fields.owners.current.length} \u2192 ${fields.owners.new.length}`,
    );
  if (fields.tags)
    parts.push(
      `tags: ${fields.tags.current.length} \u2192 ${fields.tags.new.length}`,
    );
  if (fields.enabled) parts.push(fields.enabled.new ? 'enable' : 'disable');
  if (fields.muted) parts.push(fields.muted.new ? 'mute' : 'unmute');

  return parts.join(', ') || 'no changes';
};

export const formatCloudTestChangeSummary = (
  change: AgentCloudTestConfigChange,
  operation: AgentTestOperation,
): string => {
  if (operation === 'delete') {
    return 'delete test';
  }
  if (isAgentCloudTestCreateChange(change)) {
    const configSummary = formatCloudTestConfigFieldsSummary(change);
    return `Create ${change.testType} test — ${configSummary}`;
  }
  return formatCloudTestConfigFieldsSummary(change);
};

export const formatCloudTestChangeLabel = (
  change: AgentCloudTestConfigChange,
): string => {
  if (isAgentCloudTestCreateChange(change)) {
    return change.assetId;
  }
  return change.testId;
};
